import { FieldInputProps, useField } from "formik";
import * as React from "react";

import { formatSSN } from "../../../utils/formatSSN";

import { Label } from "../Label";

import styles from '../forms.module.css';


interface SocialSecurityNumberProps {
    label: string;
    id: string;
    name: string;
    placeholder?: string;
    hideLabel?: boolean;
    fullWidth?: boolean;
    required?: boolean;
    onChange?: (stuff: any, field: any) => void;
    autoComplete?: boolean;
}

const SocialSecurityNumber: React.FC<SocialSecurityNumberProps> = ({
    id,
    label,
    required = false,
    fullWidth = false,
    hideLabel = false,
    onChange,
    autoComplete = false,
    ...props
}) => {
    const [field, meta, helper] = useField(props as any);

    const handleChange = (field: FieldInputProps<any>, e: React.FormEvent<HTMLInputElement>) => {
        if (onChange) onChange(field, e);

        field.onChange(e);
    };

    const handleBlur = (field: FieldInputProps<any>, e: React.FormEvent<HTMLInputElement>) => {
        helper.setTouched(true);

        if (e.currentTarget.value) {
            helper.setValue(formatSSN(e.currentTarget.value));
        }
    };

    return (
        <>
            <Label label={label} hideLabel={hideLabel} id={id} required={required} />
            <input
                {...field}
                className={styles.InputElement}
                type="text"
                placeholder="XXX-XX-XXXX"
                style={{
                    width: fullWidth ? "100%" : "auto",
                    borderLeft: required && hideLabel ? '2px solid var(--color-DarkGrey)' : '',
                }}
                autoComplete={autoComplete ? "on" : "off"}
                onBlur={(e) => handleBlur(field, e)}
                onChange={(e) => handleChange(field, e)}
                data-qa={`form-input-social-security-number-${id}`}
            />
            {meta.touched && meta.error && (
                <div className={styles.Error}>
                    <span>{meta.error}</span>
                </div>
            )}
        </>
    );
};

export { SocialSecurityNumber };